const esMessages = {
    dropdowns: {
        nodata: 'Sin resultados',
        clear: 'Limpiar',
        comboArrowBtnAriaLabelExpand: 'Abre la lista de opciones',
        comboArrowBtnAriaLabelCollapse: 'Cierra la lista de opciones',
        dropDownListArrowBtnAriaLabel: 'Selecciona'
    }
}

export default esMessages